import { useEffect } from 'react';
import {
  ConsoleLogger,
  DefaultDeviceController,
  DefaultMeetingSession,
  LogLevel,
  MeetingSessionConfiguration
} from 'amazon-chime-sdk-js';

import { useVirtualVenueState, useVirtualVenueActions } from './VirtualVenueContext';

const VirtualVenueLoader = ({ meeting, attendee }) => {
  const state = useVirtualVenueState();
  const {
    initializeState,
    setMeetingSession,
    setAudioVideoDevicesAreChosen,
    onError,
  } = useVirtualVenueActions();

  // Initialize state on mount
  useEffect(() => {
    initializeState();
  }, []);

  // Initialize meeting session
  useEffect(() => {
    if (!state?.virtualVenue) return;

    const logger = new ConsoleLogger('MyLogger', LogLevel.WARN);

    const deviceController = new DefaultDeviceController(logger);

    const configuration = new MeetingSessionConfiguration({
      "MeetingId": meeting.meetingId,
      "MediaPlacement": {
        "AudioHostUrl": meeting.mediaPlacement.audioHostUrl,
        "ScreenDataUrl": meeting.mediaPlacement.screenDataUrl,
        "ScreenSharingUrl": meeting.mediaPlacement.screenSharingUrl,
        "ScreenViewingUrl": meeting.mediaPlacement.screenViewingUrl,
        "SignalingUrl": meeting.mediaPlacement.signalingUrl,
        "TurnControlUrl": meeting.mediaPlacement.turnControlUrl
      }
    },
    {
      "ExternalUserId": attendee.external_user_id,
      "AttendeeId": attendee.attendee_id,
      "JoinToken": attendee.join_token
    });

    const session = new DefaultMeetingSession(
      configuration,
      logger,
      deviceController
    );

    setMeetingSession(session);
  }, [state?.virtualVenue]);

  // Choose audio/video devices
  useEffect(() => {
    if (!!state?.virtualVenue?.meetingSession && !state?.virtualVenue?.audioVideoDevicesAreChosen) {
      Promise.all([
        state.virtualVenue.meetingSession.audioVideo.listAudioInputDevices(),
        state.virtualVenue.meetingSession.audioVideo.listAudioOutputDevices(),
        state.virtualVenue.meetingSession.audioVideo.listVideoInputDevices()
      ]).then((devices) => {
        return Promise.all([
          state.virtualVenue.meetingSession.audioVideo.chooseAudioInputDevice(devices[0][0].deviceId),
          state.virtualVenue.meetingSession.audioVideo.chooseAudioOutputDevice(devices[1][0].deviceId),
          state.virtualVenue.meetingSession.audioVideo.chooseVideoInputDevice(devices[2][0].deviceId)
        ]);
      }).then(() => {
        setAudioVideoDevicesAreChosen(true);
      }).catch((error) => {
        console.log(error);
        onError({
          feedbackMessage: 'Failed to choose audio/video devices',
          feedbackVariant: 'error'
        });
      })
    }
  }, [state?.virtualVenue?.meetingSession, state?.virtualVenue?.audioVideoDevicesAreChosen]);

  return null;
};

export default VirtualVenueLoader;
